<!-- Mobile/Desktop Header -->
<div class="mb-20 md:mb-0">
  <div
    class="mobile-header fixed left-0 right-0 top-0 z-10 rounded-bl-[16px] bg-primary-normal lg:static lg:rounded-bl-lg"
  >
    <div class="flex items-center justify-between py-5">
      @if (currentPage?.name === "Inicio") {
        <img
          class="ml-4 w-[35%] lg:hidden lg:w-auto"
          src="assets/images/logo-white.svg"
          alt="Logo"
        />
        <div class="hidden lg:block">
          <span
            class="ml-3 flex items-center font-freightSansProBold text-2xl text-white lg:ml-5 lg:h-[70px] lg:text-4xl"
          >
            {{ currentPage?.name }}
          </span>
        </div>
      } @else {
        <span
          class="ml-6 flex h-[58px] items-center font-freightSansProBold text-[26px] text-white lg:ml-5 lg:h-[70px] lg:text-4xl"
        >
          {{ currentPage?.name }}
        </span>
      }
      <!-- Desktop -->
      <div class="flex items-center">
        <div
          class="lg:hidden"
          (click)="toggleSidebar()"
          (keydown)="toggleSidebar()"
          tabindex=""
        >
          <img class="mr-3" src="assets/icons/menu.svg" alt="menu" />
        </div>
        <div class="hidden pr-5 lg:block">
          <div class="hidden lg:flex lg:gap-4">
            <button
              [routerLink]="'mi-cuenta'"
              routerLinkActive="button-icon-active"
              [disabled]="isMyAccountActive"
              class="button-icon-hover flex items-center gap-3 rounded-lg bg-[#33587a] px-7 py-3 font-montserratSemiBold text-white lg:text-base"
            >
              <img
                src="assets/icons/menu-user.svg"
                alt="user-icon"
                class="h-6"
              />
              <img
                src="assets/icons/filled-user-icon.svg"
                alt="user-icon"
                class="h-6"
              />
              Mi cuenta
            </button>
            <button
              (mouseenter)="onMouseEnterNotifications()"
              (mouseleave)="onMouseLeaveNotifications()"
              (click)="showNotifications()"
              class="flex items-center gap-3 rounded-lg bg-[#33587a] px-7 py-3 font-montserratSemiBold text-white lg:text-base"
            >
              <div class="relative">
                @if (this.newNotifications) {
                  <span
                    class="absolute right-0 top-0 z-20 flex h-[10px] w-[10px]"
                  >
                    <span
                      class="absolute inline-flex h-full w-full animate-ping rounded-full bg-tertiary-normal opacity-75"
                    ></span>
                    <span
                      class="absolute inline-flex h-[10px] w-[10px] rounded-full bg-tertiary-hover"
                    ></span>
                  </span>
                }
                <img
                  [src]="notificationIconSrc"
                  alt="notification"
                  class="z-10 h-6"
                />
              </div>
              Notificaciones
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Overlay -->
@if (isSidebarVisible) {
  <div
    class="overlay fixed bottom-0 left-0 top-0 z-40 w-1/5 bg-primary-strong bg-opacity-80"
    (click)="toggleSidebar()"
    (keydown)="toggleSidebar()"
    tabindex=""
  ></div>
}
<!-- Mobile Sidebar -->
<div
  class="fixed bottom-0 right-0 top-0 z-50 h-full w-4/5 transform overflow-y-auto rounded-l-xl bg-primary-normal text-white transition-transform duration-500 md:w-2/5 lg:hidden"
  [ngClass]="{ 'translate-x-full': !isSidebarVisible }"
>
  <div class="h-full p-5">
    <div class="mt-3 flex items-center justify-between">
      <div class="flex items-center">
        <img
          (click)="toggleSidebar()"
          (keydown)="toggleSidebar()"
          src="assets/icons/arrow-left.svg"
          alt="arrow-left"
          tabindex=""
        />
        <img class="ml-4" src="assets/images/logo-white.svg" alt="Logo" />
      </div>
      <button class="relative" (click)="showNotifications()">
        @if (this.newNotifications) {
          <span class="absolute right-0 top-0 z-20 flex h-[10px] w-[10px]">
            <span
              class="absolute inline-flex h-full w-full animate-ping rounded-full bg-tertiary-normal opacity-75"
            ></span>
            <span
              class="absolute inline-flex h-[10px] w-[10px] rounded-full bg-tertiary-hover"
            ></span>
          </span>
        }
        <img src="assets/icons/notification.svg" alt="notification" />
      </button>
    </div>
    <!-- Sidebar Content -->
    <div
      class="mt-6-on-small-height flex h-full flex-col justify-around space-y-10"
    >
      <div>
        <button
          class="my-8 flex w-full items-center justify-between rounded-lg bg-[#33587a] p-3 text-left"
          (click)="navigateToPage(menuItems.items[menuItems.items.length - 1])"
          (keydown)="
            navigateToPage(menuItems.items[menuItems.items.length - 1])
          "
        >
          @if (menuItems.items.length > 0) {
            <div class="flex items-center">
              <img
                [src]="
                  'assets/icons/' +
                  menuItems.items[menuItems.items.length - 1].icon +
                  '.svg'
                "
                alt="user-icon"
                class="h-5 w-5"
              />
              <span class="ml-4 font-montserratSemiBold text-[15px]">{{
                menuItems.items[menuItems.items.length - 1].name
              }}</span>
            </div>
          }
          <img src="assets/icons/arrow-right.svg" alt="arrow-right-icon" />
        </button>
        <ul class="space-y-4">
          @for (
            item of menuItems.items.slice(0, 8);
            track item;
            let i = $index
          ) {
            <li>
              @if (i === 6 && hasPermission("Salud")) {
                <p
                  class="-ml-3 mb-2 mt-4 px-2 font-freightSansProSemibold text-[15px] uppercase text-primary-disabled"
                >
                  SALUD JUST
                </p>
              }
              @if (item.showInMenu && hasPermission(item.category)) {
                <div class="flex flex-col">
                  <!-- Button for normal item or expandable -->
                  <button
                    class="flex w-full items-center justify-between p-2 text-left"
                    (click)="navigateToPage(item)"
                  >
                    <div class="flex items-center">
                      <img
                        class="mr-4"
                        [src]="
                          item.name === 'Rescate 365'
                            ? 'assets/icons/rescate-white.svg'
                            : currentPage?.name === item.name
                              ? 'assets/icons/' + item.icon + '-selected.svg'
                              : 'assets/icons/' + item.icon + '-default.svg'
                        "
                        [alt]="item.icon"
                      />
                      <span
                        [ngClass]="{
                          'font-freightSansProBold':
                            currentPage?.name === item.name,
                          'font-freightSansProMedium':
                            currentPage?.name !== item.name,
                        }"
                      >
                        {{ item.name }}
                      </span>
                    </div>
                  </button>
                </div>
              }
            </li>
          }
        </ul>
      </div>

      <div>
        <!-- Contáctanos manual -->
        <div class="text-white">
          <button
            class="flex w-full items-center p-2 text-left"
            (click)="navigateToPage(menuItems.items[8])"
          >
            <img
              class="mr-4"
              [src]="
                currentPage?.name === 'Contáctanos'
                  ? 'assets/icons/contacto-selected.svg'
                  : 'assets/icons/contacto-default.svg'
              "
              alt="contacto"
            />
            <span
              [ngClass]="{
                'font-freightSansProBold': currentPage?.name === 'Contáctanos',
                'font-freightSansProMedium':
                  currentPage?.name !== 'Contáctanos',
              }"
            >
              {{ menuItems.items[8].name }}
            </span>
          </button>
        </div>

        <button
          (click)="signOut()"
          class="my-4 flex w-full items-center p-2 text-left"
        >
          <img
            class="mr-4"
            src="assets/icons/cerrar-sesion-default.svg"
            alt="cerrar-sesion-icon"
          />
          <span class="font-freightSansProMedium">Cerrar sesión</span>
        </button>

        <div class="mb-4 space-y-4 rounded-lg bg-[#33587a] p-4">
          <p class="font-freightSansProSemiBold text-[15px] italic">
            Síguenos en nuestras redes sociales
          </p>
          <div class="flex items-center justify-start space-x-6">
            @for (network of SOCIAL_NETWORKS; track network) {
              <a [href]="network.url" target="_blank">
                <img
                  [src]="'assets/icons/' + network.icon + '.svg'"
                  [alt]="network.alt"
                  class="h-4 w-4"
                />
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Notifications -->
<app-notification
  [isNotificationVisible]="openNotifications"
  (closeNotificationBar)="openNotifications = $event.valueOf()"
  (unViewedNotifications)="this.toggleUnViewedNotification($event)"
></app-notification>
